import React, { useContext, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import useWindowDimensions from '../hooks/useWindow';
import { designNumbers } from '../data';
import { ApparelContext } from '../context/FlowContext';
import { sendIframeHeight } from '../utils/iframePostMessage';

const JerseyType = ({ nextStep }) => {
  const horizontalSliderRef = useRef(null);
  const { addApparelType } = useContext(ApparelContext);
  const { width } = useWindowDimensions();

  useEffect(() => {
    setTimeout(() => {
      sendIframeHeight();
    }, 1000);
  }, [width]);

  const handleSelectJerseyType = type => {
    let jerseyType = type;

    addApparelType(jerseyType, designNumbers?.apparel?.[jerseyType]?.variants);

    nextStep();
  };

  const handleScroll = direction => {
    console.log('handleScroll', direction);
    const scrollPosition = horizontalSliderRef.current.scrollLeft;
    const padding = width < 991 ? 40 : 200;
    if (direction === 'right') {
      horizontalSliderRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollPosition + width - padding,
      });
    } else {
      horizontalSliderRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollPosition - width - padding,
      });
    }
  };

  return (
    <StyledFormStep
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      <h2>Select garment type</h2>

      <div className="horizontal-slide-container" ref={horizontalSliderRef}>
        {Object.keys(designNumbers.apparel).map(type => (
          <div
            className="jersey-type-container"
            key={type}
            onClick={() => handleSelectJerseyType(type)}
          >
            <motion.img
              src={`https://res.cloudinary.com/team-triton/image/upload/f_auto,q_auto,w_450/apparel/type/${type}`}
              alt={`${type} apparel type`}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 1.1 }}
            />
            <h3 className="apparel">{type.split('_').join(' ')}</h3>
            {designNumbers.apparel[type]?.msrp && (
              <p className="msrp">MSRP ${designNumbers.apparel[type].msrp}</p>
            )}
          </div>
        ))}

        <button
          className="move-btn prev-options-btn"
          onClick={() => handleScroll('left')}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enableBackground="new 0 0 100 100"
            xmlSpace="preserve"
          >
            <path d="M50,25.406L7.908,5v29.972v9.652v29.969L50,95l42.092-20.408V44.624v-9.652V5L50,25.406z M17.003,19.517L50,35.514  l32.997-15.997v19.408L50,54.922L17.003,38.925V19.517z M82.997,68.895L50,84.893L17.003,68.895V49.489L50,65.487l32.997-15.998  V68.895z" />
          </svg>
        </button>

        <button
          className="move-btn more-options-btn"
          onClick={() => handleScroll('right')}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 100 100"
            enableBackground="new 0 0 100 100"
            xmlSpace="preserve"
          >
            <path d="M50,25.406L7.908,5v29.972v9.652v29.969L50,95l42.092-20.408V44.624v-9.652V5L50,25.406z M17.003,19.517L50,35.514  l32.997-15.997v19.408L50,54.922L17.003,38.925V19.517z M82.997,68.895L50,84.893L17.003,68.895V49.489L50,65.487l32.997-15.998  V68.895z" />
          </svg>
        </button>
      </div>
    </StyledFormStep>
  );
};

const StyledFormStep = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 50px 20px 100px;

  @media (max-width: 991px) {
    padding: 20px 20px 100px;
  }

  h2 {
    margin-top: 0;
    text-transform: uppercase;
    font-weight: bold;
    text-align: center;
  }

  .back-btn {
    background-color: rgba(250, 0, 0, 0.7);
    color: #fff;
    border-radius: 4px;
    padding: 4px 8px;
    border: none;
    cursor: pointer;
  }

  .horizontal-slide-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    max-height: 1200px;
    gap: 40px;
    align-self: flex-start;
    padding: 20px 20px 80px;
    position: relative;
    scroll-snap-type: x mandatory;
    overflow-x: auto;
  }

  .button-row {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .move-btn {
    position: fixed;
    top: 325px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    background: linear-gradient(to right, rgba(150, 150, 150, 0), var(--red));
    padding-left: 30px;
    font-size: 40px;
    border: none;
    cursor: pointer;
    transition: all 0.25s ease-in-out;

    &.more-options-btn {
      right: 0;
    }

    &.prev-options-btn {
      left: 0;
      transform: rotate(180deg);
    }

    svg {
      width: 50px;
      transform: rotate(270deg);
      fill: #fff;
    }

    &:hover {
      background: linear-gradient(to right, rgba(250, 0, 0, 0.3), var(--red));
    }

    @media (max-width: 767px) {
      padding-left: 10px;

      svg {
        width: 30px;
      }
    }
  }

  .jersey-type-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin-bottom: 1rem;
    max-width: 60%;

    img {
      width: 250px;
    }

    h3 {
      background-color: #c9040399;
      color: #fff;
      text-align: center;
      text-transform: uppercase;
      width: 100%;
      padding: 0.5rem;
      pointer-events: none;
      font-size: 2rem;
      margin-block: 10px;
    }

    .msrp {
      color: var(--red);
      margin-block: 0;
    }

    @media (max-width: 550px) {
      margin: 0 20px;
      width: 80vw;
      scroll-snap-align: center;

      img {
        width: 100%;
      }

      h3 {
        top: 32%;
      }
    }
  }
`;

export default JerseyType;
